import React, { Fragment } from 'react';
import T from 'prop-types';

import ThresholdBadge from '../../../../components/ThresholdBadge';
import { numberToPercentage } from '../../../../utils/formatter';

const formatValue = (rawValue, configs) => `${rawValue < 0 ? '-' : '+'}${numberToPercentage(Math.abs(rawValue), configs)}`;

const ForecastChangeBox = ({
  value,
  change,
  labelValue,
  labelChange,
}) => (
  <div className="forecast-change-box">
    <div className="forecast-change-box__left">
      <p className="forecast-change-box__label">{labelValue}</p>
      <p className="forecast-change-box__value forecast-change-box__value-with-abbr">
        {value ? (
          <Fragment>
            <span>{formatValue(value, { precision: 0, strip_insignificant_zeros: true })}</span>
            <span className="change-abbr">YoY</span>
          </Fragment>
        ) : <span className="text-quiet">—</span>}
      </p>
    </div>
    <div className="forecast-change-box__right">
      <p className="forecast-change-box__label">{labelChange}</p>
      <div className="forecast-change-box__value">
        {change ? (
          <span>{formatValue(change, { precision: 1, strip_insignificant_zeros: false })}</span>
        ) : <span className="text-quiet">—</span>}
      </div>
    </div>
  </div>
);

ForecastChangeBox.propTypes = {
  value: T.oneOfType([T.number, T.string]),
  change: T.oneOfType([T.number, T.string]),
  labelValue: T.string,
  labelChange: T.string,
};

export default ForecastChangeBox;

export const ForecastRestrictedBox = ({
  change,
  label,
}) => {
  const decoratedChange = change ? parseFloat(change).toFixed(1) : null;

  return (
    <div className="forecast-restricted-box">
      <p className="forecast-restricted-box__label">{label}</p>
      <div className="forecast-restricted-box__body">
        <div className="forecast-restricted-box__value">
          {decoratedChange ? (
            <span>
              {formatValue(decoratedChange, { precision: 1, strip_insignificant_zeros: false })}
            </span>
          ) : <span className="text-quiet">—</span>}
        </div>
        <ThresholdBadge
          value={decoratedChange}
          threshold={[1, -1]}
        />
      </div>
    </div>
  );
};

ForecastRestrictedBox.propTypes = {
  change: T.oneOfType([T.number, T.string]),
  label: T.string,
};
